const STYLES = {
  active: { pill: 'bg-surface-container text-secondary font-semibold', dot: 'bg-secondary', label: 'Active' },
  inactive: { pill: 'bg-surface-container-high text-on-surface-variant', dot: 'bg-outline', label: 'Inactive' },
  unknown: { pill: 'bg-surface-container text-on-surface-variant', dot: 'bg-outline-variant', label: '—' },
};

/** Active / Inactive pill from the design. `status`: 'active' | 'inactive' | 'unknown'. */
export default function StatusPill({ status }) {
  const s = STYLES[status] ?? STYLES.unknown;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] leading-[14px] whitespace-nowrap ${s.pill}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} aria-hidden="true" />
      {s.label}
    </span>
  );
}
